import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import { fixedSelectCheck } from "./fixed-select-check";
import { styled, useTheme } from "@mui/material/styles";

const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
  "&.Mui-selected": {
    backgroundColor: theme.palette.background.button,
    color: theme.palette.text.white,
    "&:hover": {
      backgroundColor: theme.palette.background.button,
    },
  },
}));

const FixedSelectInput = ({
  valueSpec,
  onChange,
  onError,
  useBiToggle = false,
  multiSelect = false,
}) => {
  const [value, setValue] = useState(multiSelect ? [] : null);
  const [error, setError] = useState(null);
  const [enums, setEnums] = useState([]);
  const theme = useTheme();

  useEffect(() => {
    console.log(valueSpec);
    setValue(valueSpec.value);
    setEnums(valueSpec.enums || []);
    const err = checkValue(valueSpec.value, valueSpec);
    if (err) {
      setError(true);
      onError(true);
    }
    return () => {};
  }, [valueSpec]);

  const handleToggle = (e, v) => {
    const err = checkValue(v, valueSpec);
    setValue(v);
    setError(err);
    onChange(v);
    onError(err);
  };

  const checkValue = (value, spec) => {
    if (multiSelect) {
      for (let i = 0; i < value.length; i++) {
        const err = !fixedSelectCheck(value[i], spec);
        if (err) {
          return err;
        }
      }
      return false;
    } else {
      const err = !fixedSelectCheck(value, spec);
      return err;
    }
  };

  const handleChange = e => {
    const err = !fixedSelectCheck(e.target.value, valueSpec);
    setValue(e.target.value);
    setError(err);
    onChange(e.target.value);
    onError(err);
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Grid container spacing={1} direction="column">
        {valueSpec.name && (
          <Grid item xs>
            <Typography variant="h6">{valueSpec.name}</Typography>
          </Grid>
        )}
        {useBiToggle && !multiSelect && enums.length === 2 ? (
          <Grid item xs>
            <ToggleButtonGroup
              value={value}
              exclusive
              fullWidth
              onChange={handleToggle}
            >
              <CustomToggleButton value={valueSpec.enums[0]}>
                {valueSpec.enums[0]}
              </CustomToggleButton>
              <CustomToggleButton value={valueSpec.enums[1]}>
                {valueSpec.enums[1]}
              </CustomToggleButton>
            </ToggleButtonGroup>
          </Grid>
        ) : (
          <>
            {value !== null && (
              <Grid item xs>
                <FormControl fullWidth>
                  <InputLabel id="simple-select-label">
                    Select an Option
                  </InputLabel>
                  <Select
                    labelId="simple-select-label"
                    id="simple-select"
                    value={value}
                    label="Select an Option"
                    onChange={handleChange}
                    multiple={multiSelect}
                    error={error}
                    renderValue={selected =>
                      multiSelect ? selected.join(", ") : selected
                    }
                  >
                    {enums.map(option => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
          </>
        )}
      </Grid>
    </Box>
  );
};

export default FixedSelectInput;
